import React, {Component} from 'react';
import {Row, Col, Progress, Card, ButtonToolbar, Alert, CardHeader, CardTitle, FormGroup, Label, Form, Input, CardBody, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem, FormText, InputGroup,  Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import { RIEToggle, RIEInput, RIETextArea, RIENumber, RIETags, RIESelect } from 'riek'
import Popover from 'react-awesome-popover';
import "react-awesome-popover/dest/react-awesome-popover.css";

const colorOptions = [
    { id: "info", text: "Info"},
    { id: "primary", text: "Primary"},
    { id: "secondary", text: "Secondary"},
    { id: "success", text: "Success"},
    { id: "warning", text: "Warning"},
    { id: "danger", text: "Danger"},
    { id: "light", text: "Light"},
    { id: "dark", text: "Dark"},
    { id: "indigo", text: "Indigo"},
];

class TagBindingStructure extends Component {

    constructor(props) {
        super(props);
        this.valueChanged = this.valueChanged.bind(this);
    }
    componentDidMount() {
    }
    componentWillUnmount(){
    }
    valueChanged(e) {
        this.props.change(e);
    }
    render() {

        return (
            <Popover
                placement="bottom"
            >
                <Button color="light" className="btn btn-block btn-sm float-right text-secondary"><i className="fa fa-pencil"></i></Button>
                <Card className="mt-0 mb-0 shadow tagEditor">
                    <CardHeader>
                        TagEditor
                    </CardHeader>
                    <CardBody>
                        <Row>
                            <Col xs="12">
                                <i className="fa fa-tag mr-2 text-muted"></i>
                                <RIESelect
                                    value={this.props.valueTag}
                                    className="editable text-developer"
                                    options={this.props.optionsTag}
                                    change={this.valueChanged}
                                    classLoading="loading"
                                    propName={this.props.propNameTag}
                                />
                            </Col>
                        </Row>
                        {!this.props.fillBar && (<hr className="mb-4"/>)}
                        {!this.props.fillBar && (
                            <Row>
                                <Col xs="12">
                                    <i className="fa fa-circle-o mr-2 text-muted"></i>
                                    <RIESelect
                                        value={this.props.valueBit}
                                        className="editable text-developer"
                                        options={this.props.optionsBit}
                                        change={this.valueChanged}
                                        classLoading="loading"
                                        propName={this.props.propNameBit}
                                    />
                                </Col>
                            </Row>
                        )}

                    </CardBody>
                    {this.props.isBool && (
                        <div>
                            <CardHeader>
                                Bool
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="2">
                                        1:
                                    </Col>
                                    <Col xs="5">
                                        <RIEInput
                                            value={this.props.valueBoolConfig.trueMsg}
                                            className="editable text-developer"
                                            change={this.valueChanged}
                                            propName={`${this.props.propNameBoolConfig}.trueMsg`}
                                        />
                                    </Col>
                                    <Col xs="4">
                                        <RIESelect
                                            value={this.props.valueBoolConfig.trueColor}
                                            className={`editable text-${this.props.valueBoolConfig.trueColor.id}`}
                                            options={colorOptions}
                                            change={this.valueChanged}
                                            classLoading="loading"
                                            propName={`${this.props.propNameBoolConfig}.trueColor`}
                                        />
                                    </Col>
                                </Row>
                                <hr className="mb-3"/>
                                <Row>
                                    <Col xs="2">
                                        0:
                                    </Col>
                                    <Col xs="5">
                                        <RIEInput
                                            value={this.props.valueBoolConfig.falseMsg}
                                            className="editable text-developer"
                                            change={this.valueChanged}
                                            propName={`${this.props.propNameBoolConfig}.falseMsg`}
                                        />
                                    </Col>
                                    <Col xs="4">
                                        <RIESelect
                                            value={this.props.valueBoolConfig.falseColor}
                                            className={`editable text-${this.props.valueBoolConfig.falseColor.id}`}
                                            options={colorOptions}
                                            change={this.valueChanged}
                                            classLoading="loading"
                                            propName={`${this.props.propNameBoolConfig}.falseColor`}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </div>
                    )}
                    {(this.props.valueScale !== undefined && this.props.valueOffset !== undefined) && (
                        <div>
                            <CardHeader>
                                Units
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="3">
                                        Scale
                                    </Col>
                                    <Col xs="3">
                                        {this.props.valueScale !== undefined ?
                                            <RIENumber
                                                value={this.props.valueScale}
                                                className="editable text-developer"
                                                change={this.valueChanged}
                                                propName={this.props.valueNameScale}
                                            />: "N/A"}
                                    </Col>
                                </Row>
                                <hr className="mb-4"/>
                                <Row>
                                    <Col xs="3">
                                        Offset
                                    </Col>
                                    <Col xs="3">
                                        {this.props.valueOffset !== undefined ?
                                            <RIENumber
                                                value={this.props.valueOffset}
                                                className="editable text-developer"
                                                change={this.valueChanged}
                                                propName={this.props.valueNameOffset}
                                            /> : "N/A"}
                                    </Col>
                                </Row>
                                <hr className="mb-4"/>
                                <Row>
                                    <Col xs="3">
                                        Dec
                                    </Col>
                                    <Col xs="3">
                                        {this.props.valueDecimals !== undefined ?
                                            <RIENumber
                                                value={this.props.valueDecimals}
                                                className="editable text-developer"
                                                change={this.valueChanged}
                                                propName={this.props.valueNameDecimals}
                                            /> : "N/A"}
                                    </Col>
                                </Row>
                            </CardBody>
                        </div>
                    )}
                    {this.props.fillBar && (
                        <div>
                            <CardHeader>
                                Min/Max
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="3">
                                        Min
                                    </Col>
                                    <Col xs="3">
                                        <RIENumber
                                            value={this.props.valueTagMin}
                                            className="editable text-developer"
                                            change={this.valueChanged}
                                            propName={this.props.valueNameTagMin}
                                        />
                                    </Col>
                                    <Col xs="3">
                                        Max
                                    </Col>
                                    <Col xs="3">
                                        <RIENumber
                                            value={this.props.valueTagMax}
                                            className="editable text-developer"
                                            change={this.valueChanged}
                                            propName={this.props.valueNameTagMax}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="3">
                                        E Min
                                    </Col>
                                    <Col xs="3">
                                        <RIENumber
                                            value={this.props.valueEngMin}
                                            className="editable text-developer"
                                            change={this.valueChanged}
                                            propName={this.props.valueNameEngMin}
                                        />
                                    </Col>
                                    <Col xs="3">
                                        E Max
                                    </Col>
                                    <Col xs="3">
                                        <RIENumber
                                            value={this.props.valueEngMax}
                                            className="editable text-developer"
                                            change={this.valueChanged}
                                            propName={this.props.valueNameEngMax}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </div>
                    )}

                </Card>
            </Popover>
        )
    }
}
TagBindingStructure.defaultProps = {
    fillBar : false,
    isBool : false
};

export default TagBindingStructure;



// WEBPACK FOOTER //
// ./src/views/site/Developer/DeveloperOverviewRender/Support/TagBindingStructure.js